const rankings = [
  { rank: 1, title: '星际迷航：新纪元', tag: '科幻', hot: '今日播放 128.6万', trend: 'up' },
  { rank: 2, title: '夜雨江湖', tag: '武侠', hot: '今日播放 96.3万', trend: 'up' },
  { rank: 3, title: '深海迷城', tag: '冒险', hot: '今日播放 87.9万', trend: 'new' },
  { rank: 4, title: '荒野追凶', tag: '悬疑', hot: '今日播放 72.4万', trend: 'up' },
  { rank: 5, title: '月下奇谭', tag: '奇幻', hot: '今日播放 65.8万', trend: 'down' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="lg:w-[380px] flex-shrink-0">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 border border-primary-200 mb-4">
              <i className="ri-trophy-line text-primary-600 text-sm"></i>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">实时热度</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50 mb-3">
              热播榜单
            </h2>
            <p className="text-sm md:text-base text-foreground-200 mb-8">
              实时更新全网最热电影播放排行，发现大家都在看什么
            </p>
            <a
              href="#cards"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold whitespace-nowrap rounded-full bg-primary-500 text-foreground-950 cursor-pointer hover:bg-primary-400 transition-all duration-200 active:scale-95"
            >
              查看全部热门电影
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="flex-1 w-full">
            <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
              {rankings.map((item, i) => (
                <a
                  key={i}
                  href="#cards"
                  className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer transition-colors hover:bg-background-200/40 ${
                    i < rankings.length - 1 ? 'border-b border-background-200/40' : ''
                  }`}
                >
                  <div className={`flex-shrink-0 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-xl font-heading text-base md:text-lg font-bold whitespace-nowrap ${
                    item.rank === 1
                      ? 'bg-accent-500 text-foreground-950'
                      : item.rank === 2
                      ? 'bg-primary-500 text-foreground-950'
                      : item.rank === 3
                      ? 'bg-secondary-500 text-foreground-950'
                      : 'bg-background-200 text-foreground-200'
                  }`}>
                    {item.rank}
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <h3 className="text-sm md:text-base font-semibold text-foreground-50 whitespace-nowrap">
                        {item.title}
                      </h3>
                      <span className="text-xs px-2 py-0.5 rounded-full bg-background-200 text-foreground-300 whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-xs text-foreground-300 mt-1">{item.hot}</p>
                  </div>

                  <div className="flex-shrink-0 flex items-center gap-3">
                    {item.trend === 'up' && (
                      <span className="flex items-center gap-1 text-xs font-medium text-accent-500 whitespace-nowrap">
                        <i className="ri-arrow-up-line"></i>上升
                      </span>
                    )}
                    {item.trend === 'new' && (
                      <span className="flex items-center gap-1 text-xs font-medium text-primary-500 whitespace-nowrap">
                        <i className="ri-sparkling-line"></i>新上榜
                      </span>
                    )}
                    {item.trend === 'down' && (
                      <span className="flex items-center gap-1 text-xs font-medium text-secondary-500 whitespace-nowrap">
                        <i className="ri-arrow-down-line"></i>下降
                      </span>
                    )}
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 group-hover:bg-primary-100 transition-colors">
                      <i className="ri-play-circle-line text-foreground-300 text-sm"></i>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}